import {
  concession,
  otherDocs2,
  commons,
  commonsOtherDocs2,
  others,
  concessionLetterRequired,
} from '../constants';
import { initialValuesGenerator } from '../initialValueGenerator';
import { dynamicRule } from '../rules';

export const MATDocs = () => {
  const rules = {
    anexoRG: dynamicRule('required'),
    anexoCPF: dynamicRule('required'),
    anexoCarta: dynamicRule('aposentado'),
    anexoCienciaConcessao: dynamicRule('naoJulgado'),

    anexoDecisao: dynamicRule(),
    anexoSB40Etc: dynamicRule('decisao'),

    anexoCTPS: dynamicRule('naoAposentado'),
    anexoCertReservista: dynamicRule(),
  };

  const docs = {
    commons: [...commons, ...others],
    Aposentado: [...concessionLetterRequired],
    Tutela: [...concessionLetterRequired, ...concession],
    NaoAposentado: [...otherDocs2, ...commonsOtherDocs2],
  };

  const initialValues = initialValuesGenerator(docs);

  return {
    initialValues,
    rules,
    docs,
  };
};
